export default __webpack_public_path__ + "static/media/Urine.2456720b.svg";